import { localized } from '@platform/core/lib/localized';
import type { ICatalog, Lang } from '@platform/core/types';
import type { ILinkCandidateType } from './ILinkCandidateType';

/**
 * Типи записів простору в порядку ws.modules прототипу (каталог простору: recordTypes[].order; тип без порядку — не таблиця простору,
 * не пропонується): головний тип — під назвою модуля, дочірня таблиця — під своєю назвою (у прототипі кожна таблиця — окремий модуль:
 * «Законопроєкти» · «Поправки»). Чиста функція.
 */
export function linkCandidateTypes(catalog: ICatalog | undefined, lang: Lang): ILinkCandidateType[] {
  const ordered: { type: ILinkCandidateType; order: number }[] = [];
  for (const m of catalog?.modules ?? []) {
    if (m.installed === false) continue;
    for (const r of m.recordTypes) {
      const { order } = r;
      if (typeof order !== 'number') continue;
      ordered.push({ type: { module: m.key, rt: r.key, label: localized(r.main ? m.name : r.name, lang) || r.key, count: r.recordCount }, order });
    }
  }
  return ordered.sort((a, b) => a.order - b.order).map((x) => x.type);
}
